import React, { useState, useEffect } from 'react';

const LoadingScreen = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => {
            setIsVisible(false);
            onComplete?.();
          }, 500);
          return 100;
        }
        return prev + Math.random() * 15;
      });
    }, 100);

    return () => clearInterval(timer);
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] bg-[#1a1a1a] flex flex-col items-center justify-center transition-opacity duration-500 ${
        progress >= 100 ? 'opacity-0' : 'opacity-100'
      }`}
    >
      {/* Animated Logo */}
      <div className="relative mb-8">
        <img 
          src="/assets/logo-wellcargo.png" 
          alt="Well Cargo" 
          className="w-32 h-auto animate-pulse"
          style={{
            opacity: progress / 100,
            transition: 'opacity 0.3s ease'
          }}
        />
      </div>

      {/* Progress Bar */}
      <div className="w-48 h-1 bg-gray-800 rounded-full overflow-hidden mt-4">
        <div
          className="h-full bg-gradient-to-r from-[#3ECDA3] to-[#2fa882] rounded-full transition-all duration-300 ease-out"
          style={{ width: `${Math.min(progress, 100)}%` }}
        ></div>
      </div>

      {/* Loading Text */}
      <p className="text-gray-500 text-sm mt-4 animate-pulse">
        Carregando...
      </p>
    </div>
  );
};

export default LoadingScreen;
